import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Component, OnInit, ViewChild } from "@angular/core";
import {
  FormBuilder,
  Validators
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Store } from "@ngrx/store";
import { CookieService } from "ngx-cookie-service";
import { Subscription } from "rxjs";
import { breadcrumbItem } from "src/app/components/breadcrumbs/breadcrumbs.model";
import { AddonsService } from "src/app/core/services/addons/addons.service";
import { AlertService } from "src/app/core/services/AlertService/alert.service";
import { locationBroadcastService } from "src/app/core/services/loaction-broadcast.service";
import { ApiService } from "src/app/services/api";
import { BreadcrumbService } from "src/app/services/breadcrumb";
import { TimezoneService } from "src/app/services/timezone";
import { AppState } from "src/app/store/app.state";

@Component({
  selector: 'app-new-license',
  templateUrl: './new-license.component.html',
  styleUrls: ['./new-license.component.scss']
})
export class NewLicenseComponent implements OnInit {
  @ViewChild("copyClipboard", {}) private copyClipboard;

  breadcrumbItems: breadcrumbItem[] = [
    {
      label: 'Home',
      active: false,
      url: "/home",
    },
    {
      label: 'Licenses',
      active: false,
      url: "/licenses",
    },
    {
      label: 'New License',
      active: true,
      url: "",
    }
  ];

  licenseForm: any;
  storeId: any = "";
  params: any = new HttpParams();
  httpOptions = {};
  headerToken = {
    "Content-Type": "application/json",
    Authorization: this.cookieService.get("token"),
  };

  GLOBALURL = this.ApiService.getBaseURL();
  isLoadingChangeSub: Subscription;
  isLoading = false;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private locService: locationBroadcastService,
    private cookieService: CookieService,
    private toastr: AlertService,
    private ApiService: ApiService,
    private http: HttpClient,
    private store: Store<AppState>,
    private addonsService: AddonsService,
    private BreadcrumbService: BreadcrumbService,
    private modalService: NgbModal,
    private timezoneService: TimezoneService,
  ) {
    this.GLOBALURL = this.ApiService.getBaseURL();
  }

  isModalOpen = false;
  ngOnInit(): void {
    if (this.modalService.hasOpenModals()) {
      console.log("hasOpenModals-Adding-CSS");
      this.isModalOpen = true;
    }

    if(!this.isModalOpen) {
      this.BreadcrumbService.setValue(this.breadcrumbItems);
    }

    if (this.cookieService.get("superAdminPage") !== "3") {
      this.toastr.error('Logged-in account should be a Super Admin.')
      this.router.navigate(['/home']);
      return;
    }

        // check if user is allowed to visit the page
        // if (this.cookieService.get("superAdminPage") === "3") {
        //   this.storeId = this.cookieService.get("storeId");

        //   this.initForm()

        // } else {
        //   this.router.navigate(["/home"]);
        // }
        this.httpOptions = {
          headers: new HttpHeaders(this.headerToken)};
        this.initForm()
  }

  initForm() {
    this.licenseForm = this.fb.group({
      expirationDate:["",[Validators.required]],
      employeeLimit:[null,[Validators.required]],
      accountLimit:[null,[Validators.required]],
      qsrLimit:[null,[Validators.required]],
      kdsLimit:[null,[Validators.required]],
      kioskLimit:[null,[Validators.required]],
      fullLimit:[null,[Validators.required]],
      price:[null,[Validators.required]]
    })

  }

  get f() {
    return this.licenseForm;
  }
  closeCopy(){
    this.modalService.dismissAll(this.copyClipboard);
  }

  copylicense(){
    let val = this.licensedKey
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.modalService.dismissAll(this.copyClipboard);
    this.toastr.success("Copied")
    this.goBack()
  }
  dateToUnix(date){
    let unix =this.timezoneService.get()(date).unix();
     return unix
   }
  submitted=false
  licensedKey=""
  onSubmit(){
    //sample
    // this.licensedKey = "64546-56544-5645-456465"
    // this.modalService.open(this.copyClipboard, {
    //   centered: true,
    // });
    // return

    this.submitted=true
    let info = this.f.value
    /*current localTime
    let expDate = new Date(new Date(info.expirationDate).toString().split('GMT')[0]+' UTC').toISOString()
    */
    // UTC
    // let expDate = new Date(new Date(info.expirationDate).toISOString())
    let expDate = this.dateToUnix(info.expirationDate)
    if (this.licenseForm.valid) {
      let params ={
        expirationDate: expDate,
        employeeLimit: info.employeeLimit,
        accountLimit: info.accountLimit,
        qsrLimit: info.qsrLimit,
        kdsLimit: info.kdsLimit,
        kioskLimit:info.kioskLimit,
        fullLimit: info.fullLimit,
        price: info.price,
      }

      //create
      return this.http.post(this.GLOBALURL + '/subscription/generate', params, this.httpOptions).subscribe((response: any) => {
        if (response.success == 0) {
            this.toastr.error(response.message);
        } else {
          if (this.modalService.hasOpenModals()) {
            console.log("MODAL_OPEN");
            // this.loader = false;
            // this.detectChanges = true;
            const department = response.response;
            this.modalService.dismissAll( department );
            this.toastr.clear();
            this.toastr.success(response.message);
            return
          }
            this.toastr.success(response.message);
            response.response.newKey = this.chunk(response.response.key, 6).join('-');
            this.licensedKey = response.response.key;
            const chunks = this.licensedKey.match(/.{1,6}/g);
            this.licensedKey = chunks.join('-');
            this.modalService.open(this.copyClipboard, {
              centered: true,
            });
        }
    }, (error) => {
        const message = this.ApiService.errorMessage(error)
        this.toastr.error(message);
    });

    }
  }

  chunk(str, n) {
    var ret = [];
    var i;
    var len;
    for (i = 0, len = str.length; i < len; i += n) {
        ret.push(str.substr(i, n))
    }
    return ret
};

public closeModal2 = () => {
  this.modalService.dismissAll()
  setTimeout(() => {
    this.isModalOpen = false;
  }, 1000);
}

    // navigate back to list page
    goBack() {
      if (this.isModalOpen) {
        this.closeModal2();
        return;
      }
      this.router.navigate(["../"], { relativeTo: this.route });
    }

}
